import { CircleXIcon } from "lucide-react";

import { useToast } from "@/hooks";

export const useErrorToast = () => {
  const { toast } = useToast();

  return ({ description }: { description: string }) => {
    toast({
      description: (
        <div className="flex items-center gap-2">
          <CircleXIcon className="h-6 w-6 fill-red-600 text-white" />
          {description}
        </div>
      ),
    });
  };
};
